import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Page} from '../model/page';
import {Sube} from '../model/sube';

@Injectable({
  providedIn: 'root',
})
export class HelperProvider {

  public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public currentPage$: BehaviorSubject<Page> = new BehaviorSubject<Page>(null);
  public showConnectionError$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public changedSelectedBranches$: BehaviorSubject<Sube[]> = new BehaviorSubject<Sube[]>(null);
  public isConfirmation$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
}


